export class RangeField {
  constructor(public gte?: number, public lte?: number) { }

  public static getRangeFieldText(rangeField: RangeField, allText: string, prefix: string = ''): string {
    if ((rangeField.gte === undefined
      || rangeField.gte === 0)
      && (rangeField.lte === undefined)) {
      return allText;
    }

    if ((rangeField.gte === undefined
      || rangeField.gte === 0)
      && rangeField.lte !== undefined
      && rangeField.lte > 0) {
      return `${prefix}<${rangeField.lte}`;
    }

    if (rangeField.lte === undefined
      && rangeField.gte !== undefined
      && rangeField.gte > 0) {
      return `${prefix}${rangeField.gte}+`;
    }

    return `${prefix}${rangeField.gte}-${rangeField.lte}`;
  }
}